const { CrudModel } = require('./crud');

export class InhouseProfessionalPayrollModel extends CrudModel {
	constructor() {
		super('admin/inhouse_professional_payroll');
	}

	async generatePayroll(month: number, year: number) {
		return this.executeAction(null, "generatePayroll", { month, year });
	}

	async generateBankingFile(payrollIds: number[], bankingAccountId: number) {
		return this.executeAction(null, "generateBankingFile", { payrollIds, bankingAccountId });
	}
}

export default new InhouseProfessionalPayrollModel();
